<script setup lang="ts">
import { computed } from "vue";
import { Country_Enum } from "@/graphql";

const props = defineProps<{
  country?: Country_Enum;
}>();

const isDenmark = computed(() => props.country === Country_Enum.DENMARK);
</script>

<template>
  <div class="flex flex-col gap-4">
    <h2 class="t-sh3 text-type-default">Materials</h2>
    <div class="flex flex-col gap-3">
      <p class="t-small text-type-default">
        <strong>Materials</strong> gives an overview of the total masses of materials mapped in the project. These materials can
        be dragged and sorted into waste fractions, or a generic waste average can be applied.
      </p>
      <p class="t-small text-type-muted">Note the country-specific rules for documenting waste on the construction site.</p>
    </div>
    <div
      v-if="isDenmark"
      class="rounded-8 bg-app-blue-50 p-4">
      <p class="t-small text-app-blue-800">
        For Denmark, only the measured masses of waste on the site should be used for the final documentation. The modelled
        material masses should therefore only be used in the early design stage for investigating the potential emissions from
        waste scenarios.
      </p>
    </div>
  </div>
</template>
